/* unplugin-vue-components disabled */import { render } from "./audioplayer.vue?vue&type=template&id=4d287e92&scoped=true"
import script from "./audioplayer.vue?vue&type=script&lang=js"
export * from "./audioplayer.vue?vue&type=script&lang=js"

import "./audioplayer.vue?vue&type=style&index=0&id=4d287e92&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d287e92"],['__file',"src/controls/audioplayer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d287e92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d287e92', __exports__)) {
    api.reload('4d287e92', __exports__)
  }
  
  module.hot.accept("./audioplayer.vue?vue&type=template&id=4d287e92&scoped=true", () => {
    api.rerender('4d287e92', render)
  })

}


export default __exports__